import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  initials: 'NA',
  name: 'NA',
  isLoaded: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserProfile: (state, action) => {
      const { initials, name } = action.payload;
      state.initials = initials;
      state.name = name;
      state.isLoaded = true;
    },
    clearUserProfile: (state) => {
      state.initials = 'NA';
      state.name = 'NA';
      state.isLoaded = false;
    },
  },
});

export const { setUserProfile, clearUserProfile } = userSlice.actions;
export default userSlice.reducer;
